import { useState } from 'react';
import { Link } from 'react-router-dom';
import { gameCategories } from '@/mocks/home';

export default function GameShowcase() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredGames =
    activeCategory === 'all'
      ? gameCategories
      : gameCategories.filter((g) => g.id === activeCategory);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 mb-4">
            <i className="ri-gamepad-line text-primary-500 text-sm"></i>
            <span className="text-primary-600 text-xs font-medium">热门游戏</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            丰富多样的<span className="text-primary-600">棋牌游戏</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            汇集国内外经典棋牌玩法，满足不同类型玩家的需求
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-8 md:mb-12">
          <button
            onClick={() => setActiveCategory('all')}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              activeCategory === 'all'
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            全部游戏
          </button>
          {gameCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.id
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filteredGames.map((game) => (
            <Link
              key={game.id}
              to="/categories"
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-foreground-900/60 backdrop-blur-sm text-background-50 text-xs font-medium">
                  {game.playerCount}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center">
                    <i className={`${game.icon} text-primary-500 text-sm`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading">
                    {game.name}
                  </h3>
                </div>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                  {game.description}
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {game.features.map((f, idx) => (
                    <span
                      key={idx}
                      className="px-2.5 py-1 rounded-md bg-background-100 text-foreground-600 text-xs font-medium"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-100 text-foreground-700 font-medium text-sm hover:bg-background-200 transition-all duration-200 cursor-pointer"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}